import { ROUTE_TYPE } from 'rde-view-common/constants/Routes';

export default { ME: ROUTE_TYPE.ENTRIES };
